export default "__VITE_ASSET__C3wY4AFF__"